function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistedHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface155253133"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.450981%,55.29412%,90.980393%)",
      fillOpacity: 1
    },
    d: "M 16.375 9 C 10.117188 9 5 14.054688 5 20.28125 C 5 33.050781 19.488281 39.738281 24.375 43.78125 L 25 44.3125 L 25.625 43.78125 C 30.511719 39.738281 45 33.050781 45 20.28125 C 45 14.054688 39.882812 9 33.625 9 C 30.148438 9 27.085938 10.613281 25 13.0625 C 22.914062 10.613281 19.851562 9 16.375 9 Z M 16.375 11 C 19.640625 11 22.480469 12.652344 24.15625 15.15625 L 25 16.40625 L 25.84375 15.15625 C 27.519531 12.652344 30.359375 11 33.625 11 C 38.808594 11 43 15.144531 43 20.28125 C 43 31.179688 30.738281 37.289062 25 41.78125 C 19.261719 37.289062 7 31.179688 7 20.28125 C 7 15.144531 11.1875 11 16.375 11 Z M 16.375 11 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.450981%,55.29412%,90.980393%)",
      fillOpacity: 1
    },
    d: "M 28.9375 9.703125 C 28.9375 7.890625 29.476562 6.375 30.550781 5.164062 C 31.632812 3.953125 33.25 3.347656 35.40625 3.347656 C 37.5625 3.347656 39.203125 3.953125 40.320312 5.164062 C 41.4375 6.375 41.996094 7.890625 41.996094 9.703125 C 41.996094 11.445312 41.4375 12.90625 40.320312 14.078125 C 39.203125 15.25 37.5625 15.839844 35.40625 15.839844 C 33.25 15.839844 31.632812 15.25 30.550781 14.078125 C 29.476562 12.90625 28.9375 11.445312 28.9375 9.703125 Z M 28.9375 9.703125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistedHeart);
export default __webpack_public_path__ + "static/media/wishlistedHeart.dca12433f44f688e4d2a4d4f257af72c.svg";
export { ForwardRef as ReactComponent };